export { default } from './Epilogue'



// WEBPACK FOOTER //
// ./src/components/Epilogue/index.ts